
import {
  computed,
  defineComponent,
  getCurrentInstance,
  reactive,
  toRefs,
  ref,
  h,
} from 'vue';
import axios from 'axios';
import { ElNotification } from 'element-plus';
import { TUIEnv } from './TUIKit/TUIPlugin';
import { TUICore, genTestUserSig } from './TUIKit';
import { useStore } from 'vuex';
import TUIAegis from './TUIKit/utils/TUIAegis';
import ComponyName from './components/ComponyName.vue';
import IsLogin from './components/IsLogin.vue';
import HelloWorld from './components/HelloWorld.vue';
import { left } from '@popperjs/core';
import { onMounted } from 'vue';
import { ElMessageBox } from 'element-plus';
const SDKAppID = 1400757726; // Your SDKAppID
const secretKey =
  'eba746b5cc1ce62cd8a4df7a02128272f296a6dba656d77e2e63a7c0d27b758f'; //Your secretKey

export default defineComponent({
  name: 'App',
  components: {
    ComponyName,
    IsLogin,
    HelloWorld,
  },
  setup(props, context) {
    const instance = getCurrentInstance();
    const internalData = instance?.appContext.config.globalProperties;
    const TUIKit: any = instance?.appContext.config.globalProperties.$TUIKit;
    const store = useStore();
    const appPersonalDialogVisible = ref(false);

    const url = window.location.href;

    let allParams = url.split('?')[1]; // 获取url中的参数
    let params = new URLSearchParams(allParams);
    let MyTempName = params.get('tempname');
    const MyUserName = params.get('username');
    const MyUrl = params.get('url');
    const MyKeyWord = params.get('keyword');
    const MPageType = params.get('pagetype');
    const letter = params.get('letter');
    const userID = MyTempName;

    // 判断是否是h5 个人页面的私信
    if (letter === '1') {
      appPersonalDialogVisible.value = true;
    } else {
      appPersonalDialogVisible.value = false;
    }

    // 获取本地存储的所有访问记录
    var arr = JSON.parse(localStorage.getItem('allParams') || '[]');
    var IsParams = '';
    var isUserName = '';

    var isArr = arr.some((item: any) => {
      return (
        item?.substring(
          item?.indexOf('username=') + 9,
          item?.indexOf('&url')
        ) ===
        allParams?.substring(
          allParams?.indexOf('username=') + 9,
          allParams?.indexOf('&url')
        )
      );
    });
    // 将访问过的不同的链接保存到本地
    if (!isArr) {
      arr.push(allParams);
    }

    // 在本地存储的数据中查找与访问的链接中的tempname，username是否匹配
    IsParams = arr.find(function (str: any) {
      return (
        str.includes('tempname=' + MyTempName) &&
        str.includes('username=' + MyUserName)
      );
    });

    isUserName = IsParams?.substring(
      allParams?.indexOf('username=') + 9,
      allParams?.indexOf('&url')
    );

    // 设置本地存储的所有访问记录
    localStorage.setItem('allParams', JSON.stringify(arr));

    let clientip = JSON.parse(localStorage.getItem('clientip') || '[]');

    const MPuserName = internalData?.$cookies.get('MPuserName');

    const getElNotification = async function () {
      var releaseTime = '';
      var updateContent = '';
      // var regUpdateContent = "";
      await axios
        .get(
          '/api/TencentIM/GetAppVersion_DzscIM?appVersionNumber=102&ip=' +
            clientip
        )
        .then((res) => {
          if (res.data.successCode) {
            releaseTime = res.data.resultData.releaseTime;
            updateContent = res.data.resultData.updateContent;
            // const str = JSON.stringify(updateContent);
            // const reg = "\r\n";
            // regUpdateContent = str.replace(new RegExp(reg, "g"), "<br/>");
            // console.log(str.replace(new RegExp(reg, "g"), "<br>"));
            // console.log(updateContent);
          } else {
            // console.log("暂无数据");
          }
        })
        .catch((err) => {
          console.log(err, '失败');
        });
      const updateMessage = updateContent + '<br/>更新日期:' + releaseTime;
      updateTips(updateMessage);
    };

    TUIKit.login({
      userID: MPuserName,
      userSig: genTestUserSig({
        SDKAppID,
        secretKey,
        userID: MPuserName,
      }).userSig, // The password with which the user logs in to IM. It is the ciphertext generated by encrypting information such as userID.For the detailed generation method, see Generating UserSig
    });
    const data = reactive({
      env: TUIEnv(),
      //currentModel: 'conversation',
      menuStatus: false,
      showProfile: false,
      showAbout: false,
      showMore: false,
      showReceipt: false,
      showCancellation: false,
      showDisclaimer: false,
      currentModel: 'message',
      userInfo: TUICore.instance.getStore().TUIProfile.profile,
      toUserName: isUserName,
      allParams: IsParams,
      keyword: MyKeyWord,
      loginParams: {
        tempname: MyTempName,
        username: MyUserName,
        url: MyUrl,
        keyword: MyKeyWord,
        pagetype: MPageType,
      },
      navList: [
        {
          icon: 'message',
          name: 'message',
          label: '消息',
        },
        {
          icon: 'relation',
          name: 'group',
          label: '通讯录',
        },
        {
          icon: 'profile',
          name: 'profile',
          label: '个人中心',
        },
      ],
      currentConversationID: '',
      isSupportGroupReceipt: true,
      appPersonalDialogVisible,
    });

    const handleCurrentConversation = (value: string) => {
      console.log(value, 'handleCurrentConversation');
      // data.currentModel = value ? "message" : "conversation";
      data.currentModel = 'message';
      data.currentConversationID = value;
      // data.toUserName = value.split("C2C")[1];
    };

    TUICore.instance.TUIServer.TUIProfile.getMyProfile().then((res: any) => {
      // console.log("res.data:" + JSON.stringify(res.data));
      data.userInfo = res.data;
    });
    const taskList = computed(() => store.state.taskList);
    const version: string = TUICore.instance.TIM.VERSION;
    // const needReadReceipt = computed(() => store.state.needReadReceipt);

    // const toggleMenu = () => {
    //     data.menuStatus = !data.menuStatus;
    // };

    const selectModel = (modelName: string) => {
      data.currentModel = modelName;
    };
    const handleChangeStatus = () => {
      data.showMore = false;
      data.showProfile = false;
      TUICore.instance.TUIServer.TUIProfile.setEdit(false);
    };

    const openShowMore = () => {
      data.showMore = !data.showMore;
      if (data.showMore) {
        TUIAegis.getInstance().reportEvent({
          name: 'showMore',
          ext1: 'showMore',
        });
      }
      data.showProfile = false;
      data.showAbout = false;
      data.showReceipt = false;
      data.showCancellation = false;
    };

    const openShowReceipt = () => {
      data.showReceipt = true;
    };

    const closeShowReceipt = () => {
      data.showReceipt = false;
    };

    const exitLogin = async () => {
      // router.push({ name: "Login" });

      internalData?.$cookies.remove('MPuserName');
      //location.href = "https://www.dzsc.com";
      TUIAegis.getInstance().reportEvent({
        name: 'logout',
        ext1: 'logout-success',
      });
      location.reload();
    };
    const openShowProfile = () => {
      TUICore.instance.TUIServer.TUIProfile.setEdit(true);
      data.showProfile = true;
      data.showReceipt = false;
      TUIAegis.getInstance().reportEvent({
        name: 'showProfile',
        ext1: 'showProfile',
      });
    };
    const openShowAbout = () => {
      data.showAbout = true;
      data.showReceipt = false;
    };
    const openShowCancellation = () => {
      data.showCancellation = true;
    };
    const cancel = () => {
      data.showCancellation = false;
      data.showMore = false;
    };

    const closeShowAbout = () => {
      data.showAbout = false;
    };

    const openDisclaimer = () => {
      data.showDisclaimer = true;
    };

    const submitDisclaimer = () => {
      data.showDisclaimer = false;
      data.showMore = false;
    };

    const openDataLink = (item: any) => {
      window.open(item.url);
      TUIAegis.getInstance().reportEvent({
        name: 'openLink',
        ext1: item.label,
      });
    };

    const openLink = (type: any) => {
      window.open(type.url);
      TUIAegis.getInstance().reportEvent({
        name: 'openLink',
        ext1: type.label,
      });
    };
    const TUIServer = (window as any)?.TUIKitTUICore?.TUIServer;
    TUIServer.TUIConversation.getConversationProfile('C2C' + MyUserName).then(
      (imResponse: any) => {
        // console.log(
        //     "conversation:" + JSON.stringify(imResponse.data.conversation)
        // );
        TUIServer.TUIConversation.handleCurrentConversation(
          imResponse.data.conversation
        );
      }
    );

    function IsLessIE11() {
      var userAgent = navigator.userAgent;
      // 判断是否为小于IE11的浏览器
      var isLessIE11 =
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
      if (isLessIE11) {
        ElMessageBox.alert(
          '您当前浏览器版本过低，请升级至IE11或更换其他浏览器',
          {
            callback: () => {
              location.href = 'https://www.dzsc.com/';
              //window.open('https://www.dzsc.com/')
            },
          }
        );
      }
    }

    onMounted(() => {
      // getElNotification();
      IsLessIE11();
    });
    return {
      ...toRefs(data),
      taskList,
      // toggleMenu,
      version,
      selectModel,
      handleChangeStatus,
      openShowMore,
      openShowCancellation,
      cancel,
      closeShowAbout,
      openShowAbout,
      openDisclaimer,
      submitDisclaimer,
      openShowProfile,
      openShowReceipt,
      exitLogin,
      openLink,
      openDataLink,
      handleCurrentConversation,
      // needReadReceipt,
      closeShowReceipt,
      getElNotification,
    };
  },
});

var updateTips = (message: any) => {
  ElNotification({
    dangerouslyUseHTMLString: true,
    title: '增加匿名直接询盘功能',
    message: message,
    // "新增个人资料编辑功能<br/>1.点击对话框左下角设置图标<br/>2.点击设置中的编辑资料<br/>3.随后即可设置个人资料<br/>更新日期:2022-11-29<br/>",
    duration: 15000,
    position: 'bottom-right',
    customClass: 'updateTips', //自定义类名
  });
};
